document.addEventListener('turbolinks:load', () => {
  $('a.disabled').on('click', (event) => {
    event.preventDefault();
  });
});
